import { formatPrice } from "@/utils/utils";

interface PlanPricingProps {
  planName: string;
  price: number;
  isPopular: boolean;
  hasLegacyDiscount: boolean;
  discountMultiplier?: number;
}

export const PlanPricing = ({
  planName,
  price,
  isPopular,
  hasLegacyDiscount,
  discountMultiplier = 0.8,
}: PlanPricingProps) => {
  const isEnterprise = planName === "Enterprise";
  const textColor = isPopular ? "text-blue-900" : "text-gray-900";

  if (isEnterprise) {
    return (
      <div className={`flex flex-col items-center justify-center gap-1 ${textColor}`}>
        <div className="text-2xl font-bold">Custom</div>
      </div>
    );
  }

  if (hasLegacyDiscount) {
    const discountedPrice = price * discountMultiplier;
    return (
      <div className={`flex flex-col items-center justify-center gap-1 ${textColor}`}>
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-500 line-through">{formatPrice(price)}</span>
          <span className="text-2xl font-bold">{formatPrice(discountedPrice)}/mo</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center justify-center gap-1 ${textColor}`}>
      <div className="text-2xl font-bold">{formatPrice(price)}/mo</div>
    </div>
  );
};
